module.exports = __webpack_public_path__ + "static/media/enpScreenshot.8b5a8305.jpg";